import React from "react";
import { useTranslation } from "react-i18next";
import { graphql } from "babel-plugin-relay/macro";
import { LoginGuestMutation } from "./__generated__/LoginGuestMutation.graphql";
import { useMutation } from "relay-hooks";
import { useSetState } from "components/ReduxProvider";
import { Button } from "@mui/material";

const mutation = graphql`
  mutation LoginGuestMutation {
    loginGuest {
      token
    }
  }
`;

const LoginGuest = () => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = React.useState(false);
  const setToken = useSetState("token");

  const [loginGuest] = useMutation<LoginGuestMutation>(mutation, {
    onCompleted: ({ loginGuest }) => {
      if (loginGuest) {
        setToken(loginGuest.token);
      } else {
        setSubmitting(false);
      }
    },
    onError: () => setSubmitting(false)
  });

  const handleGuest = (e) => {
    loginGuest({ variables: {} });
    setSubmitting(true);
  };

  return (
    <Button variant="contained" color="primary" size="large" fullWidth onClick={handleGuest} disabled={submitting}>
      {t("Continue")}
    </Button>
  );
};

export default LoginGuest;
